export const MuiInputBase = {
  input: {
    padding: 0,
    height: '1.375rem',
  },
  multiline: {
    padding: 0,
  },
};
